import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import _get from 'lodash/get';

import 'Features/Bundle/components/Mystery/MysteryKey.scss';

import FixedImg from 'Components/Utility/FixedImg';
import FluidImg from 'Components/Utility/FluidImg';
import SelectedTierContext from 'Features/Bundle/context/selected-tier-context';

const MysteryKey = ({ product }) => {
  const { selectedTier } = useContext(SelectedTierContext);

  let numberOfKeys = 0;
  if (product.template_type === 'standard_mystery') {
    product.bundles.forEach((tier) => {
      numberOfKeys += tier.displayTotal;
    });
  }
  if (product.template_type === 'tiered_mystery') {
    numberOfKeys = _get(product, `bundles[${selectedTier}].displayTotal`, 0);
  }

  const mysteryArray = [];
  for (let i = 0; i < numberOfKeys; i += 1) {
    mysteryArray.push(`key${i + 1}`);
  }

  const mysteryEggBundle = product.slug === 'mystery-egg-bundle';
  const mysteryBoxBundle = product.slug === 'mystery-box-bundle';

  const mysteryEggImage = (i) => {
    let eggImg = 'Egg-2.png';
    if (i === 1 || i === 10 || i === 19) eggImg = 'Egg-3.png';
    if (i === 2 || i === 11 || i === 20) eggImg = 'Egg-4.png';
    if (i === 3 || i === 12 || i === 21) eggImg = 'Egg-5.png';
    if (i === 4 || i === 13 || i === 22) eggImg = 'Egg-6.png';
    if (i === 5 || i === 14 || i === 23) eggImg = 'Egg-7.png';
    if (i === 6 || i === 15 || i === 24) eggImg = 'Egg-8.png';
    if (i === 7 || i === 16) eggImg = 'Egg-9.png';
    if (i === 8 || i === 17) eggImg = 'Egg-10.png';
    return eggImg;
  };

  const mysteryBoxImage = (i) => {
    let boxImg = 'Box-2.png';
    if (i === 1 || i === 8 || i === 17) boxImg = 'Box-3.png';
    if (i === 2 || i === 10 || i === 18) boxImg = 'Box-4.png';
    if (i === 3 || i === 11 || i === 19) boxImg = 'Box-5.png';
    if (i === 4 || i === 12 || i === 20) boxImg = 'Box-6.png';
    if (i === 5 || i === 13 || i === 21) boxImg = 'Box-7.png';
    if (i === 6 || i === 14 || i === 22) boxImg = 'Box-8.png';
    if (i === 7 || i === 15 || i === 23) boxImg = 'Box-9.png';
    return boxImg;
  };

  if (product.slug === 'fiesta-mystery-bundle') {
    return (
      <div className="mystery-games-container">
        {mysteryArray.map((key, i) => {
          let imgUrl = 'Sweets-blue.jpg';
          if (i === 1 || i === 7 || i === 18) imgUrl = 'Sweets-purple.jpg';
          if (i === 2 || i === 10 || i === 19) imgUrl = 'Sweets-orange.jpg';
          if (i === 3 || i === 6 || i === 15) imgUrl = 'Sweets-pink.jpg';
          if (i === 4 || i === 11 || i === 13) imgUrl = 'Sweets-green.jpg';
          if (i === 5 || i === 9 || i === 17) imgUrl = 'Sweets-yellow.jpg';

          return (
            <div className="mystery-game-container" key={key}>
              <div className="mystery-cover">
                <div className="responsive-image-island">
                  <div className="responsive-image responsive-image--16by9">
                    <FluidImg
                      className="img-force-full"
                      src={imgUrl}
                      alt={name}
                      folder="assets/mystery/pinata/2023/fiesta"
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        },
        )}
      </div>
    );
  }

  return (
    <div className={classNames('mystery-games-container', { 'mystery-eggs': mysteryEggBundle }, { 'mystery-boxes': mysteryBoxBundle }, { 'four-key-row': mysteryArray.length === 8 })}>
      {mysteryArray.map((key, i) =>
        <div className="mystery-game-container" key={key}>
          <div className="mystery-game">
            <div className="top-text">
              {!mysteryEggBundle && !mysteryBoxBundle &&
                <FormattedMessage
                  id="mystery-key.header"
                  defaultMessage="Mystery Key {number}"
                  values={{
                    number: i + 1,
                  }}
                />
              }
              {mysteryEggBundle &&
                <FormattedMessage
                  id="mystery-key.header.egg"
                  defaultMessage="Mystery Egg {number}"
                  values={{
                    number: i + 1,
                  }}
                />
              }
              {mysteryBoxBundle &&
                <FormattedMessage
                  id="mystery-key.header.box"
                  defaultMessage="Mystery Box {number}"
                  values={{
                    number: i + 1,
                  }}
                />
              }
            </div>

            {!mysteryEggBundle && !mysteryBoxBundle &&
              <div className="bottom-text">
                ?
              </div>
            }

            {mysteryEggBundle &&
              <div className="custom-image">
                <FixedImg
                  fluid
                  src={mysteryEggImage(i)}
                  folder="assets/mystery/mystery-egg/2025"
                  alt="Mystery Egg"
                />
              </div>
            }

            {mysteryBoxBundle &&
              <div className="custom-image">
                <FixedImg
                  fluid
                  src={mysteryBoxImage(i)}
                  folder="assets/mystery/mystery-box/2025"
                  alt="Mystery Box"
                />
              </div>
            }
          </div>
        </div>,
      )}
    </div>
  );
};

MysteryKey.propTypes = {
  product: PropTypes.shape({}),
};

MysteryKey.defaultProps = {
  product: {},
  slug: '',
};

export default MysteryKey;
